<template>
  <nav-bar title="通知信息" />
  <Content :bottom="0" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.nid"
        @click="handleItemClick(item)"
      >
        <p>{{ item.ntitle }}</p>
        <div class="desc">
          <span>下发单位：{{ item.npublicDept }}</span>
          <span>下发时间：{{ item.npublicTime }}</span>
        </div>
      </li>
    </ul>
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="reload()" />
  </Content>
  <Popup title="通知信息" ref="popup">
    <div class="notice-content">
      <p>{{ content }}</p>
    </div>
  </Popup>
</template>

<script>
import { ref } from 'vue'
import { getNoticeList } from '@/api/user'
import { useLoadingMore } from '@/hooks/useLoadingMore'
export default {
  name: 'NotificationInformation',
  setup(props) {
    const data = useLoadingMore(getNoticeList)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    const popup = ref(null)
    const content = ref('')
    const handleItemClick = ({ ncontent }) => {
      content.value = ncontent
      popup.value.showPopup()
    }
    return {
      ...data,
      getList,
      popup,
      content,
      handleItemClick
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    p {
      margin: 0;
      line-height: 28px;
      font-weight: 600;
    }
    .desc {
      color: #666;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
  }
}
.notice-content {
  font-size: 14px;
  line-height: 26px;
  color: #333;
  padding: 16px;
}
</style>
